// extracted by mini-css-extract-plugin
export default {"addAnother":"styles_addAnother__721IH","addIcon":"styles_addIcon__KwqPM"};